import {
  AfterViewInit,
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import {
  GeneralSettingValue,
  GeneralSettingValueService,
  SocietiesService,
  Society,
  User,
} from '@pwc-bei/common';
import { I18nService, LanguageCode } from '@pwc-bei/i18n';
import {
  PwcIconsLibrary,
  pi4Quadrants,
  piBellBlack,
  piHome,
  piLogout,
  piMeeting,
  piPratiche,
  piPreventivo,
  piProfilo,
  piSettings,
  piSurveyCheckmark,
} from '@pwc-bei/icons';
import {
  AuthenticationCookie,
  AuthenticationService,
  Authority,
  AuthorizationService,
  IdleTimeoutService,
} from '@pwc-bei/security';
import {
  faChevronDown,
  faChevronUp,
} from "@fortawesome/free-solid-svg-icons";
import { ModalComponent } from '@pwc-bei/ui';
import { ToastrService } from 'ngx-toastr';
import { first, switchMap } from 'rxjs';
import { EAccessPlanVariable } from 'src/app/enum/access-plan-variable';
import { AuthorityCodeEnum } from 'src/app/enums/security/authority-code.enum';
import { ESharedDocumentType } from 'src/app/enums/shared-document-type';
import { PreviewData } from 'src/app/pages/esg/models/utils';
import { VideoCallUtilsService } from 'src/app/pages/live-assistant/services/videocall-utils.service';
import { GroupEntityService } from 'src/app/services/group-entity.service';
import { SharedDocumentUploadService } from 'src/app/services/shared-document/shared-document-upload.service';
import { SharedDocumentService } from 'src/app/services/shared-document/shared-document.service';
import { environment } from '../../../../environments/environment';
import { LogoKey } from '../../../enums/logo-key.enum';
import { RoutePath } from '../../../enums/route-path.enum';
import { CustomerProfileService } from '../../../pages/services/customer-profile.service';
import { UserProfile } from '../../../pages/user-profile/models/user-profile';
import { AuthenticationUtilsService } from '../../../services/authentication-utils.service';
import { NotificationsPanelComponent } from '../../notifications/components/notifications-panel/notifications-panel.component';
import { NotificationData } from '../../notifications/models/notification-data.model';
import { NotificationListService } from '../../notifications/services/notification-list.service';
import { UpgradePlanModalComponent } from '../../upgrade-plan/upgrade-plan-modal/upgrade-plan-modal.component';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit, AfterViewInit {
  user: User;
  authorities: AuthorityCodeEnum[] = [];
  notificationInfo: NotificationData = { notificationCount: 0 };
  userInitials = '';
  notificationInterval = environment.notificationInterval;
  environment = environment;
  documentPreview: PreviewData;

  @ViewChild('sessionTimeoutModal') sessionTimeoutModal: ModalComponent;
  @ViewChild('startupMessageModal') startupMessageModal: ModalComponent;
  @ViewChild('upgradeModal') upgradeModal: UpgradePlanModalComponent;
  @ViewChild('upgradeMessageHeaderModal')
  upgradeMessageHeaderModal: ModalComponent;
  @ViewChild('notificationPanel')
  notificationPanel: NotificationsPanelComponent;
  @Output() onLoggedUserInit: EventEmitter<User> = new EventEmitter<User>();
  @Input() enableDownloadQueue: boolean = true;

  startupMessage: SafeHtml;
  showNotificationPanel = false;
  directChannel: boolean = environment.directChannel;
  directChannelLimited: boolean = true;
  openMenu: boolean = false;
  manualFileName: string;

  faChevronDown = faChevronDown;
  faChevronUp = faChevronUp;

  showDelegateForm = false;

  readonly secondaryLogoLookup: Map<LogoKey, string> = new Map([
    [LogoKey.PWC, '/assets/images/logo.png'],
    [LogoKey.UNICREDIT, '/assets/images/logos/unicredit.png'],
    [LogoKey.P4E, '/assets/images/logos/p4e.png'],
    [LogoKey.FONDITAL, '/assets/images/logos/fondital.png'],
    [LogoKey.FIVESIXTY, '/assets/images/logos/five60.png'],
  ]);

  timeoutCountDownMessage = '';
  AuthorityCodeEnum = AuthorityCodeEnum;

  RoutePath = RoutePath;

  secondaryLogo: string = null;

  showSocietySelectionLink: boolean = false;

  showEsg = environment.esgEnabled;
  showVcf = environment.vcfEnabled;
  showAi = environment.aiEnabled;
  liveAssistantEnbaled = environment.liveAssistantEnabled;
  widgetLiveAssistantEnabled: boolean = false;

  isUserSmart: boolean = false;
  isUserPlus: boolean = false;
  isUserPremium: boolean = false;

  disabledForRoles = ['ACCESSO_B2C_OPERATORE_BANCARIO', 'ACCESSO_DIREZIONE_GENERALE'];

  viewSize: number = 4;

  currentLanguage: string = '';
  // number that represents the screen size
  // 0: xs
  // 1: sm
  // 2: md
  // 3: lg
  // 4: xl
  @HostListener("window:resize", [])
  @HostListener("window:orientationchange", [])
  updateViewSize() {
    if (window.innerWidth >= 1000) {
      this.viewSize = 4;  //xl
    } else if (window.innerWidth >= 992) {
      this.viewSize = 3;  //lg
    } else if (window.innerWidth >= 768) {
      this.viewSize = 2;  //md
    } else if (window.innerWidth >= 576) {
      this.viewSize = 1;  //sm
    } else if (window.innerWidth < 576) {
      this.viewSize = 0;  //xs
    }
  }

  constructor(private authenticationService: AuthenticationService,
    public societiesService: SocietiesService,
    private generalSettingValueService: GeneralSettingValueService,
    private notificationListService: NotificationListService,
    private router: Router,
    private toastr: ToastrService,
    private domSanitizer: DomSanitizer,
    private authenticationUtilsService: AuthenticationUtilsService,
    private authorizationService: AuthorizationService,
    private iconsLibrary: PwcIconsLibrary,
    private customerProfileService: CustomerProfileService,
    private idleTimeoutService: IdleTimeoutService,
    private videoCallUtilsService: VideoCallUtilsService,
    private sharedDocumentService: SharedDocumentService,
    private sharedDocumentUploadService: SharedDocumentUploadService,
    private groupEntityService: GroupEntityService,
    private translate: TranslateService,
    private i18nService: I18nService,
    private route: ActivatedRoute,

  ) {

    iconsLibrary.registerIcons([
      piBellBlack,
      piSettings,
      piProfilo,
      piPreventivo,
      piPratiche,
      piLogout,
      piMeeting,
      piSurveyCheckmark,
      piHome,
      pi4Quadrants,
    ]);

    idleTimeoutService.start();
    this.startupMessage = this.domSanitizer.bypassSecurityTrustHtml(
      environment.configuration.startupMessage,
    );
  }

  onTimeoutStopConfirmed() {
    // this.authenticationService.refreshToken()
    //   .subscribe((auth: AuthenticationCookie) => {
    //     this.authenticationService.setToken(auth.access_token, auth.refresh_token);
    //   }, error => {
    //     console.error(error);
    //   });
  }

  ngOnInit(): void {
    this.i18nService.lang$.subscribe((lang: string) => {
      this.currentLanguage = lang.toLowerCase();
    });
    this.updateViewSize();
    this.initLoggedUser();
    this.initSocieties();
    this.initSecondaryLogo();
    this.initNotificationsCount();
    // this.initUserManual();
    this.initProfileData();
    this.videoCallUtilsService.clearCurrentSuspendedAction();
    this.videoCallUtilsService.videoCallCurrentlyActive$.subscribe((res) => {
      if (!res) {
        this.executeIfNotInVideoConference(
          this.videoCallUtilsService.getCurrentSuspendedAction(),
        );
      }
    });
  }

  ngAfterViewInit() {
    this.showStartupMessage();
  }

  logout() {
    this.authenticationUtilsService.logout();
  }

  goHome() {
    this.router.navigate([RoutePath.HOME]);
  }

  goToChangePassword() {
    this.router.navigate([RoutePath.CHANGE_PASSWORD]);
  }

  goToServiceRequestList() {
    this.router.navigate([RoutePath.SERVICE_REQUESTS_LIST]);
  }

  get b2BLink(): string {
    return environment.appUrl.replace('/bandi', '');
  }

  inCoeSection() {
    return environment.directChannel && (
      this.currentlyIn(RoutePath.HOME) ||
      this.currentlyIn(RoutePath.THEMATIC_AREA) ||
      this.currentlyIn(RoutePath.SERVICE_REQUESTS_LIST) ||
      this.currentlyIn(RoutePath.INTRODUCTION) ||
      this.currentlyIn(RoutePath.POINT_AND_CLICK) ||
      this.currentlyIn(RoutePath.FAQ) ||
      this.currentlyIn(RoutePath.EDUCATION_AREA) ||
      this.currentlyIn(RoutePath.GLOSSARY) ||
      this.currentlyIn(RoutePath.DELEGATE) ||
      this.currentlyIn(RoutePath.CHANGE_PASSWORD))
  }

  get isCoeSection(){
    return this.inCoeSection();
  }

  private initSocieties(): void {
    this.authenticationUtilsService.loadSocieties$
      .pipe(switchMap(() => this.societiesService.getUserCompany()))
      .subscribe((societies: Society[]) => {
        if (societies.length > 1) {
          this.showSocietySelectionLink = true;
        } else {
          this.showSocietySelectionLink = false;
          this.societiesService.setSociety(societies[societies.length - 1]);
        }
      });

    this.authenticationUtilsService.loadSocieties();
  }

  currentRouteNotBlacklisted() {
    return this.router.url.indexOf('delegation') < 0;
  }

  private initLoggedUser(): void {
    this.userInitials = '';

    this.authenticationService.dataUser().subscribe((user: any) => {
      this.user = user;
      this.widgetLiveAssistantEnabled = user.liveAssistantWidgetVisible;
      this.onLoggedUserInit.emit(user);
      if (this.user != null) {
        if (this.user.firstName != null) {
          this.userInitials += this.user.firstName.substr(0, 1);
        }
        if (this.user.lastName != null) {
          this.userInitials += this.user.lastName.substr(0, 1);
        }
      }
    });

    this.authorizationService
      .getAuthorities()
      .subscribe((auths: Authority[]) => {
        this.authorities = auths.map((a) => AuthorityCodeEnum[a.code]);
        this.isUserSmart = this.authenticationUtilsService.getAccessPlan(
          EAccessPlanVariable.IS_USER_SMART,
        );
        this.isUserPlus = this.authenticationUtilsService.getAccessPlan(
          EAccessPlanVariable.IS_USER_PLUS,
        );
        this.isUserPremium = !(this.isUserSmart || this.isUserPlus);
      });
  }

  private initSecondaryLogo(): void {
    this.societiesService
      .getSelectedSociety()
      .pipe(
        switchMap((society: Society) =>
          this.generalSettingValueService.findByCode(
            'SECONDARY_LOGO',
            society.id,
          ),
        ),
      )
      .subscribe((list: GeneralSettingValue[]) => {
        if (list == null || list.length === 0) {
          this.secondaryLogo = null;
          return;
        }

        const setting = list[0];
        if (this.secondaryLogoLookup.has(setting.value as LogoKey)) {
          this.secondaryLogo = this.secondaryLogoLookup.get(
            setting.value as LogoKey,
          );
        } else {
          this.secondaryLogo = null;
        }
      });
  }

  private initNotificationsCount(): void {
    this.callNotificationsCount();
    if (this.notificationInterval > 0) {
      setInterval(() => {
        this.callNotificationsCount();
      }, environment.notificationInterval * 1000);
    }
  }

  private callNotificationsCount() {
    this.notificationListService
      .count()
      .pipe(first())
      .subscribe(
        {
          next: (count: number) => {
            this.notificationInfo.notificationCount = count;
          },
          error: (error) => {
            // console.error(error);
          },
        }
      );
  }

  showStartupMessage() {
    if (
      environment.configuration.showStartupMessage &&
      environment.configuration.startupMessage !== ''
    ) {
      // don't show startupMessage when accepting delegations
      if (
        this.router.url.indexOf(RoutePath.DELEGATION_CONFIRMED) < 0 &&
        this.router.url.indexOf(RoutePath.DELEGATION_ACCEPT) < 0
      ) {
        this.startupMessageModal.open();
      }
    }
  }

  // private initUserManual(): void {
  //   this.manualFileName = environment.esgEnabled
  //     ? environment.configuration.manualFileNameWithEsg
  //     : environment.configuration.manualFileName;
  //   this.societiesService
  //     .getSelectedSociety()
  //     .pipe(
  //       switchMap((society: Society) =>
  //         this.generalSettingValueService.findByCode(
  //           'ECOBONUS_USER_MANUAL_B2C',
  //           society.id,
  //         ),
  //       ),
  //     )
  //     .subscribe((list: GeneralSettingValue[]) => {
  //       if (list == null || list.length === 0) {
  //         return;
  //       }

  //       const setting = list[0];
  //       this.manualFileName = setting.value;
  //     });
  // }

  private initProfileData() {
    this.customerProfileService.getMyProfile().pipe(first())
      .subscribe({
        next: (profile: UserProfile) => {
          this.showDelegateForm = profile.luEdited && profile.canEditProfile;

          this.groupEntityService.findByUserId(profile.userId, null).subscribe(groupEntityList => {
            let disable = false;
            groupEntityList.forEach(groupEntity => {
              if (this.disabledForRoles.includes(groupEntity.groupCode)) {
                disable = true
              }
            })
            if (disable) {
              //this.ngxLoader.stop();
              this.directChannelLimited = true;
            } else {
              this.directChannelLimited = false
            }
          })
        }, error: error => this.showDelegateForm = false
      })
  }

  showAdvisory() {
    let res = false;

    if (this.user) {
      res =
        environment.configuration.advisory &&
        (this.user.userType === 'PARTNER_ADVISORY' ||
          this.authorities.indexOf(
            AuthorityCodeEnum.ROLE_ECOBONUS_B2C_ADVISORY_ACCESS,
          ) >= 0);
    }
    return res;
  }

  goToHomepageB2B() {
    this.authenticationService.cookie.subscribe(
      (cookie: AuthenticationCookie) => {
        window.location.href = `${environment.homeUrlB2b}`;
      },
    );
  }

  get hideForPrivacy(): boolean {
    if (!environment.configuration.showPrivacy) {
      return false;
    }

    if (this.user == null) {
      return true;
    }

    return !this.user.privacy;
  }

  goToIncentivi() {
    // window.location.href = `${environment.appUrl}/incentivi/tax-break`;
    this.router.navigate([RoutePath.INCENTIVI, RoutePath.TAX_BREAK]);
  }

  goToBandi() {
    // window.location.href = `${environment.appUrl}/bandi/tax-break`;
    this.router.navigate([RoutePath.BANDI, RoutePath.TAX_BREAK]);
  }

  goToFAQ() {
    // window.location.href = `${environment.appUrl}/bandi/faq`;
    if (this.currentlyInDeep(RoutePath.INCENTIVI, 0)) {
      this.router.navigate([RoutePath.INCENTIVI, RoutePath.FAQ]);
    } else if (this.currentlyInDeep(RoutePath.BANDI, 0)) {
      this.router.navigate([RoutePath.BANDI, RoutePath.FAQ]);
    } else {
      let fragment = ''
      // home education area
      if (this.currentlyInDeep(RoutePath.HOME, 0))
        fragment = RoutePath.HOME
      else if (this.currentlyInDeep(RoutePath.THEMATIC_AREA, 0))
        if (this.currentlyInDeep(RoutePath.ESG, 1))
          fragment = RoutePath.ESG
        else if (this.currentlyInDeep(RoutePath.DIGITAL, 1))
          fragment = RoutePath.DIGITAL
        else if (this.currentlyInDeep(RoutePath.ENERGETIC, 1))
          fragment = RoutePath.ENERGETIC
        else if (this.currentlyInDeep(RoutePath.CYBERSECURITY, 1))
          fragment = RoutePath.CYBERSECURITY
      this.router.navigate([RoutePath.BANDI, RoutePath.FAQ], { fragment: fragment });
    }

  }

  currentlyInEsg() {
    let currentPath = window.location.pathname;
    currentPath = currentPath.slice(1, currentPath.length);
    return currentPath === RoutePath.ESG;
  }

  currentlyInBandi() {
    if (this.currentlyInFaq()) return false;
    let currentPath = window.location.pathname;
    currentPath = currentPath.split('/').slice(1, currentPath.length)[0];
    return currentPath === RoutePath.BANDI;
  }

  currentlyInFaq() {
    let currentPath = window.location.pathname;
    let ref = currentPath.split('/').slice(1, currentPath.length);
    return (ref.length > 1 && ref[1] === RoutePath.FAQ)
  }

  currentlyInIncentivi() {
    if (this.currentlyInFaq()) return false;
    let currentPath = window.location.pathname;
    currentPath = currentPath.split('/').slice(1, currentPath.length)[0];
    return currentPath === RoutePath.INCENTIVI;
  }

  currentlyInDeep(pathName: string, deep: number) {
    let currentPath = window.location.pathname;
    currentPath = currentPath.split('/').slice(1, currentPath.length)[deep];
    return currentPath === pathName;

  }

  currentlyInHome() {
    let currentPath = window.location.pathname;
    currentPath = currentPath.slice(1, currentPath.length);
    return currentPath === RoutePath.HOME;
  }

  currentlyInThematicArea() {
    let currentPath = window.location.pathname;
    currentPath = currentPath.split('/').slice(1, currentPath.length)[0];
    return currentPath === RoutePath.THEMATIC_AREA;
  }

  checkPlanBeforeRedirect(redirect: string) {
    if (this.isCoeSection || !(this.isUserSmart || this.isUserPlus) || redirect == 'faq' || redirect == 'glossary') {
      sessionStorage.setItem('saved-redirect', redirect);
      this.executeIfNotInVideoConference('goToEducationRedirect');
    } else {
      this.openUpgradeModal()
    }
  }

  openUpgradeModal(){
    // utente responsabile
    if (this.user.userType.localeCompare('OPERATING_USER') != 0) {
      this.upgradeModal.openModal();
    } else {
      this.upgradeMessageHeaderModal.open();
    }
  }

  goToRedirect() {
    const redirect = sessionStorage.getItem('saved-redirect');
    sessionStorage.removeItem('saved-redirect');
    // window.location.href = `${environment.appUrl}/bandi/${redirect}`;
    this.router.navigate([RoutePath.BANDI, redirect]);
  }

  goToEducationRedirect(){
    const redirect = sessionStorage.getItem('saved-redirect');
    sessionStorage.removeItem('saved-redirect');
    // window.location.href = `${environment.appUrl}/bandi/${redirect}`;
    if (this.currentlyIn(RoutePath.INCENTIVI)){
      this.router.navigate([RoutePath.INCENTIVI, redirect]);
    }
    else if(this.currentlyIn(RoutePath.BANDI) || this.currentlyIn(RoutePath.LIVE_ASSISTANT)
      || this.currentlyIn(RoutePath.USER_PROFILE)  || this.currentlyIn(RoutePath.RDP)){
        if(this.currentlyIn(RoutePath.LIVE_ASSISTANT) && redirect === RoutePath.FAQ){
          this.router.navigate([RoutePath.BANDI, redirect], {fragment: RoutePath.LIVE_ASSISTANT});
        }
        else {
          this.router.navigate([RoutePath.BANDI, redirect]);
        }
    }
    else if(!this.isCoeSection){
      this.router.navigate([RoutePath.BANDI, redirect]);
    }
    else if(this.isCoeSection){
      let fragment = this.route.snapshot.fragment
      // home education area
      if(!fragment){
        if(this.currentlyIn(RoutePath.HOME) ||
            this.currentlyIn(RoutePath.SERVICE_REQUESTS_LIST) ||
            this.currentlyIn(RoutePath.INTRODUCTION) ||
            this.currentlyIn(RoutePath.POINT_AND_CLICK)
          )
        fragment = RoutePath.HOME
      else if (this.currentlyIn(RoutePath.THEMATIC_AREA))
        if(this.currentlyInDeep(RoutePath.ESG,1))
          fragment = RoutePath.ESG
        else if(this.currentlyInDeep(RoutePath.DIGITAL,1))
          fragment = RoutePath.DIGITAL
        else if(this.currentlyInDeep(RoutePath.ENERGETIC,1))
          fragment = RoutePath.ENERGETIC
        else if(this.currentlyInDeep(RoutePath.CYBERSECURITY,1))
          fragment = RoutePath.CYBERSECURITY
      }

      this.router.navigate([RoutePath.HOME, redirect], {fragment: fragment});
    }
  }

  goToVideoconferenceList() {
    this.router.navigate([RoutePath.LIVE_ASSISTANT]);
  }

  goToRdpList() {
    this.authenticationService.cookie.subscribe(
      (cookie: AuthenticationCookie) => {
        this.router.navigate([RoutePath.RDP, RoutePath.LIST]);
      },
    );
  }

  goToQuotation() {
    if (this.currentlyInDeep(RoutePath.BANDI, 0))
      this.router.navigate([
        RoutePath.BANDI,
        RoutePath.QUOTATION
      ])
    else if (this.currentlyInDeep(RoutePath.INCENTIVI, 0))
      this.router.navigate([
        RoutePath.INCENTIVI,
        RoutePath.QUOTATION
      ])
  }

  goToProject() {
    if (this.currentlyInDeep(RoutePath.BANDI, 0))
      this.router.navigate([
        RoutePath.BANDI,
        RoutePath.PROJECT
      ])
    else if (this.currentlyInDeep(RoutePath.INCENTIVI, 0))
      this.router.navigate([
        RoutePath.INCENTIVI,
        RoutePath.PROJECT
      ])
  }

  goToHelpDesk() {
    if (this.currentlyInDeep(RoutePath.INCENTIVI, 0)) {
      this.router.navigate([
        RoutePath.INCENTIVI,
        RoutePath.HELPDESK_LIST
      ])
    } else {
      this.router.navigate([
        RoutePath.BANDI,
        RoutePath.HELPDESK_LIST
      ])
    }
  }

  executeIfNotInVideoConference(functionName: string) {
    this.videoCallUtilsService.setCurrentSuspendedAction(functionName);
    const subscr = this.videoCallUtilsService.videoCallCurrentlyActive$
      .pipe(first())
      .subscribe((res) => {
        console.warn('res ', res);
        if (res) {
          this.videoCallUtilsService.actionNeedsModalConfirmationSubject.next(
            true,
          );
        } else {
          this.executeFnFromName(functionName);
        }
      });
  }

  executeFnFromName(functionName: string) {
    if (functionName) {
      this[functionName as keyof typeof HeaderComponent]();
    }
  }

  getB2CManual(): void {
    const docType = ESharedDocumentType.STD_USER_MANUAL_B2C;
    this.sharedDocumentUploadService.downloadDoc(docType);
  }

  availableLanguages(): string[] {
    return this.translate.getLangs();
  }

  changeLanguage(language: string) {
    if(environment.configuration.multilanguage){
      this.currentLanguage = language;
      localStorage.setItem('userLang', language);
      window.location.reload();
    }
  }

  currentlyIn(pathName: string) {
    let currentPath = window.location.pathname;
    currentPath = currentPath.split('/').slice(1, currentPath.length)[0];
    return currentPath === pathName;
  }

}
